import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import { isPhoneOrHighScreen } from '../../utilities/sizeUtils';

export function ConfirmLeaveDialog({
  uit,
  open,
  setOpenConfirmDialog,
  handleCloseDialog,
}: {
  uit?: string;
  open: boolean;
  setOpenConfirmDialog: Dispatch<SetStateAction<boolean>>;
  handleCloseDialog: () => void;
}) {
  const { t } = useTranslation();

  function handleLeave(): void {
    setOpenConfirmDialog(false);
    handleCloseDialog();
  }

  function handleStay(): void {
    setOpenConfirmDialog(false);
  }

  return (
    <Dialog
      open={open}
      onClose={handleStay}
      slotProps={{
        paper: {
          sx: isPhoneOrHighScreen()
            ? {
                position: 'fixed',
                bottom: 0,
                left: 0,
                right: 0,
                margin: 0,
                width: '100%',
                maxWidth: '100%',
                borderRadius: '16px 16px 0 0',
                paddingBottom: 'var(--bottom-nav-bar-height)',
              }
            : {},
        },
      }}
    >
      <DialogTitle component="h6">{t('etransport.dialog.leave.unsaved.title') + ' (' + uit + ')!'}</DialogTitle>
      <DialogContent>
        <Typography variant="body1" gutterBottom>
          {t('etransport.dialog.leave.unsaved.text')}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleLeave}
          variant="outlined"
          sx={{
            backgroundColor: 'white',
            color: 'var(--mui-palette-secondary-main)',
            border: '2px solid var(--mui-palette-secondary-main)',
            '&:hover': {
              backgroundColor: 'rgba(146, 102, 21, 0.1)',
            },
          }}
        >
          {t('etransport.dialog.leave.button.leave')}
        </Button>
        <Button
          onClick={handleStay}
          variant="contained"
          sx={{
            backgroundColor: 'var(--mui-palette-secondary-main)',
            '&:hover': {
              backgroundColor: 'var(--mui-palette-secondary-light)',
            },
          }}
        >
          {t('etransport.dialog.leave.button.save')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
